<template>
  <div
    class="tab-pane show"
    id="pills-chat"
    role="tabpanel"
    aria-labelledby="pills-chat-tab"
    v-bind:class="
      $route.name == 'Rooms' || $route.name == 'Room' ? 'active' : ''
    "
  >
    <!-- Start chats content -->
    <div class="d-flex container-fluid px-0 align-items-start">
      <div
        class="overlay-content bg-light bg-opacity-25 d-flex justify-content-between align-items-center col px-3 py-2"
      >
        <div class="user-chat-nav p-2">
          <div class="d-flex w-100 align-items-center">
            <div class="flex-grow-1">
              <h4 class="">List of topics</h4>
            </div>
          </div>
        </div>
        <div
          v-if="$store.state.modules.account.user.roles == 'administrator'"
          class="flex-shrink-0 p-2"
        >
          <div
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-placement="bottom"
            title="Add new Topic"
          >
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              title="Add new Topic"
              data-bs-toggle="modal"
              data-bs-target="#addContact-exampleModal"
            >
              <i class="bx bx-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Start chat-message-list -->
    <div v-if="rooms" class="p-1" data-simplebar>
      <div id="listofrooms" class="accordion accordion-flush">
        <div class="accordion-item">
          <div class="accordion-header" id="listoffavoriterooms">
            <button
              class="accordion-button font-size-14 fw-medium collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefavoriterooms"
              aria-expanded="true"
              aria-controls="collapsefavoriterooms"
            >
              <i class="bx bxs-book-bookmark me-3 text-primary"></i>
              <span class="text-uppercase">My favorite Topics</span>
            </button>
          </div>
          <!--data-bs-parent="#listofrooms"-->
          <div
            id="collapsefavoriterooms"
            class="accordion-collapse collapse show"
            aria-labelledby="listoffavoriterooms"
          >
            <div class="accordion-body">
              <div class="" data-simplebar>
                <div class="chat-message-list">
                  <ul class="list-unstyled chat-user-list list-group">
                    <li
                      v-for="(item, index) in myrooms"
                      :key="index"
                      :id="'contact-id-' + item.uid"
                      @click="test"
                      v-bind:class="
                        $route.name == 'Room' && $route.params.id == item.uid
                          ? 'active text-primary'
                          : ''
                      "
                    >
                      <router-link
                        :to="{ name: 'Room', params: { id: item.uid } }"
                        class="unread-msg-user"
                        custom
                        v-slot="{ navigate }"
                      >
                        <div
                          role="link"
                          @click="navigate"
                          class="d-flex align-items-center list-rooms-link_pointer"
                          @keypress.enter="navigate"
                        >
                          <div class="overflow-hidden">
                            <span class="font-size-16 text-truncate">
                              {{ item.title }}
                            </span>
                          </div>
                          <div class="ms-auto">
                            <span class="badge text-muted rounded-pill">{{
                              item.count
                            }}</span>
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <div class="accordion-header" id="listofotherrooms">
            <button
              class="accordion-button font-size-14 fw-medium"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseotherrooms"
              aria-expanded="true"
              aria-controls="collapseotherrooms"
            >
              <i class="bx bxs-food-menu me-3 text-primary"></i>
              <span class="text-uppercase">Other Topics</span>
            </button>
          </div>
          <!-- data-bs-parent="#listofrooms"-->
          <div
            id="collapseotherrooms"
            class="accordion-collapse collapse show"
            aria-labelledby="listofotherrooms"
          >
            <div class="accordion-body">
              <div class="" data-simplebar>
                <div class="chat-message-list">
                  <ul class="list-unstyled chat-user-list list-group">
                    <li
                      v-for="(item, index) in rooms"
                      :key="index"
                      :id="'contact-id-' + item.uid"
                      @click="test"
                      v-bind:class="
                        $route.name == 'Room' && $route.params.id == item.uid
                          ? 'active text-primary'
                          : ''
                      "
                    >
                      <router-link
                        :to="{ name: 'Room', params: { id: item.uid } }"
                        class="unread-msg-user"
                        custom
                        v-slot="{ navigate }"
                      >
                        <div
                          role="link"
                          @click="navigate"
                          class="d-flex align-items-center list-rooms-link_pointer"
                          @keypress.enter="navigate"
                        >
                          <div class="overflow-hidden">
                            <span class="font-size-16 text-truncate">
                              {{ item.title }}
                            </span>
                          </div>
                          <div class="ms-auto">
                            <span class="badge text-muted rounded-pill">{{
                              item.count
                            }}</span>
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End chat-message-list -->

    <!-- Start Add contact Modal -->
    <div
      v-if="$store.state.modules.account.user.roles == 'administrator'"
      class="modal fade"
      id="addContact-exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addContact-exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content modal-header-colored shadow-lg border-0">
          <div class="modal-header">
            <h5
              class="modal-title text-white font-size-16"
              id="addContact-exampleModalLabel"
            >
              Create new Topic
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white btn btn-sm"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body p-4">
            <form>
              <div class="mb-3">
                <label for="title" class="form-label">Title</label>
                <input
                  type="text"
                  class="form-control"
                  id="title"
                  aria-describedby="title"
                  v-model="title"
                />
              </div>
              <div class="mb-3">
                <label for="content" class="form-label">Description</label>
                <textarea
                  class="form-control"
                  id="content"
                  v-model="description"
                  rows="5"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal">
              Cancel
            </button>
            <button @click="submit(1)" class="btn btn-primary me-2">
              <span data-bs-dismiss="modal">Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Add contact Modal -->
  </div>
</template>

<script>
export default {
  name: "Rooms",

  data() {
    return {
      rooms: undefined,
      myrooms: undefined,
      title: "",
      description: "",
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$route.name == "SearchRooms") {
        this.loadFoundRoom();
      } else {
        this.loadRoom();
      }
    });
  },
  methods: {
    // change name
    test() {
      document.querySelector(".user-chat").classList.add("user-chat-show");
    },
    loadRoom() {
      // this.$store.state.utils.loaded = false;
      // THIS FOR All Rooms
      this.$store.state.modules.api.getRooms("uid", 0, 100).then((resp) => {
        this.rooms = resp.data.units;
        // THIS FOR My Rooms
        this.$store.state.modules.api
          .getAllRooms(JSON.parse(localStorage.account).token, 0, 100)
          .then((resp) => {
            this.myrooms = resp.data.units;
            this.$store.state.utils.loaded = true;
          });
      });
    },

    submit(state) {
      event.preventDefault();
      if (this.title.length > 3 && this.description.length > 5) {
        const data = {
          status: state,
          title: this.title,
          description: this.description,
        };
        console.log(data);
        this.$store.state.modules.api
          .setRoom(data, JSON.parse(localStorage.account).token)
          .then((resp) => {
            console.log(resp);
            if (resp.status == 200) {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "success",
                  message: "success uploaded your Post",
                },
                2500
              );
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  message: "Check the entries are correct",
                },
                2500
              );
            }
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Check the entries are correct",
          },
          2500
        );
      }
    },
  },
};
</script>
